import React from "react";
import styled from "styled-components";
import { homeLayoutContainerStyles } from "styles/homeLayout";
import { minTablet, mobile } from "utils/styles";
import { DetailsHeader } from "./DetailsHeader";

const Container = styled.div`
  ${homeLayoutContainerStyles}
  border-top: unset;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;

  ${mobile`
    height: 100vh;
  `}

  ${minTablet`
    background-color: #ececec;
    justify-content: flex-end;
    min-height: 100vh;
  `}
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ffffff;
  flex: 1;
  overflow-y: auto;
`;

const ContentWrapper = styled.div`
  padding: 0 18px;
  width: 100%;
  box-sizing: border-box;
`;

export const DetailsLayout = ({ children, title, onBack, className, isCloseButton = false, topRight = <></> }) => {
  return (
    <Container className={className}>
      <ContentContainer>
        <DetailsHeader title={title} onBack={onBack} isCloseButton={isCloseButton} topRight={topRight} />
        <ContentWrapper>{children}</ContentWrapper>
      </ContentContainer>
    </Container>
  );
};
